import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

export const useRemoveQueryStringParams = () => {
  const navigate = useNavigate();
  const { search, pathname } = useLocation();

  const removeQueryParams = useCallback(
    (params: string[]) => {
      const searchParams = new URLSearchParams(search);
      params.forEach((param) => searchParams.delete(param));
      navigate(`${pathname}?${searchParams}`, { replace: true });
    },
    [search, navigate, pathname]
  );

  return { removeQueryParams };
};
